import React, { useState } from 'react';
import { Box, Typography, Paper, Button, CircularProgress } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../config/firebase';

const DebugPermissionsPage: React.FC = () => {
  const { currentUser, setCurrentUser } = useAuth();
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const addMissingPermissions = async () => {
    if (!currentUser) {
      setMessage('لا يوجد مستخدم حالي');
      return;
    }

    setLoading(true);
    setMessage('جاري إضافة الصلاحيات المفقودة...');

    try {
      // تحديث الصلاحيات في Firestore
      const userRef = doc(db, 'users', currentUser.id);

      // إضافة صلاحية canAccessDebts إذا كانت غير موجودة
      const updatedPermissions = {
        ...currentUser.permissions,
        canAccessDebts: true
      };

      await updateDoc(userRef, {
        permissions: updatedPermissions
      });

      // تحديث المستخدم الحالي في الذاكرة
      setCurrentUser({
        ...currentUser,
        permissions: updatedPermissions
      });

      setMessage('تم إضافة الصلاحيات بنجاح. يرجى تحديث الصفحة لرؤية التغييرات.');
    } catch (error) {
      console.error('Error updating permissions:', error);
      setMessage('حدث خطأ أثناء تحديث الصلاحيات');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        تصحيح صلاحيات المستخدم
      </Typography>

      <Paper sx={{ p: 3, mb: 3 }}>
        <Typography variant="h6" gutterBottom>
          معلومات المستخدم الحالي
        </Typography>

        {currentUser ? (
          <Box>
            <Typography>الاسم: {currentUser.name}</Typography>
            <Typography>البريد الإلكتروني: {currentUser.email}</Typography>
            <Typography>الدور: {currentUser.role}</Typography>

            <Typography variant="subtitle1" sx={{ mt: 2 }}>
              الصلاحيات:
            </Typography>

            <Box component="pre" sx={{
              bgcolor: '#f5f5f5',
              p: 2,
              borderRadius: 1,
              overflow: 'auto',
              maxHeight: '300px'
            }}>
              {JSON.stringify(currentUser.permissions, null, 2)}
            </Box>
          </Box>
        ) : (
          <Typography>لا يوجد مستخدم مسجل الدخول</Typography>
        )}
      </Paper>

      <Paper sx={{ p: 3 }}>
        <Typography variant="h6" gutterBottom>
          إصلاح الصلاحيات
        </Typography>

        <Button
          variant="contained"
          color="primary"
          onClick={addMissingPermissions}
          disabled={loading || !currentUser}
          sx={{ mr: 2 }}
        >
          إضافة صلاحية الوصول للديون
        </Button>

        {loading && <CircularProgress size={24} sx={{ ml: 2 }} />}

        {message && (
          <Typography
            color={message.includes('بنجاح') ? 'success.main' : 'error.main'}
            sx={{ mt: 2 }}
          >
            {message}
          </Typography>
        )}
      </Paper>
    </Box>
  );
};

export default DebugPermissionsPage;
